import Vue from 'vue';
import Vuex from 'vuex';
import * as types from './mutation-types';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: false,
    userIsAdmin: false,
  },
  mutations: {
    /* eslint-disable no-param-reassign */
    [types.SET_USER](state, user) {
      state.user = user;
      state.userIsAdmin = user.roles.indexOf('ROLE_ADMIN') > -1;
    },
    /* eslint-enable no-param-reassign */
  },
  actions: {
    setUser({ commit }, user) {
      commit(types.SET_USER, user);
    },
  },
  getters: {
    user: state => state.user,
    isAdmin: state => state.userIsAdmin,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js